import { IRequest } from '../ServerApi/types/IRequest';
import { MaxRequestArrayLength } from '../services/ServerService';

export module RequestHelper {

  export const DefaultBlockSize = MaxRequestArrayLength;

  export function makeBlocks<TItem>(items: TItem[], blockSize: number): TItem[][] {
    if (items.length <= blockSize) return [items]; // optimize for common case
    const blocks: TItem[][] = [];
    const numBlocks = Math.ceil(items.length / blockSize);
    for (let i = 0; i < numBlocks; i++) {
      blocks[i] = items.slice(i * blockSize, (i+1) * blockSize);
    }
    return blocks;
  }

  export function buildRequests<TItem, TParams, TResult>(
    items: TItem[],
    buildRequest: (block: TItem[]) => IRequest<TParams, TResult>,
    blockSize: number = DefaultBlockSize
  ): IRequest<TParams, TResult>[] {
    const requests: IRequest<TParams, TResult>[] = [];
    const blocks = makeBlocks(items, blockSize);
    for (let i = 0, l = blocks.length; i < l; i++) {
      const request = buildRequest(blocks[i]);
      if (!!request) requests.push(request);
    }
    return requests;
  }

  export function buildRequests2<TItem1, TItem2, TParams, TResult>(
    items1: TItem1[],
    items2: TItem2[],
    buildRequest: (block1: TItem1[], block2: TItem2[]) => IRequest<TParams, TResult>,
    blockSize: number = DefaultBlockSize
  ): IRequest<TParams, TResult>[] {
    const requests: IRequest<TParams, TResult>[] = [];
    const blocks1 = makeBlocks(items1, blockSize);
    const blocks2 = makeBlocks(items2, blockSize);
    for (let i1 = 0, l1 = blocks1.length; i1 < l1; i1++) {
      for (let i2 = 0, l2 = blocks2.length; i2 < l2; i2++) {
        const request = buildRequest(blocks1[i1], blocks2[i2]);
        if (!!request) requests.push(request);
      }
    }
    return requests;
  }

  export function buildRequests3<TItem1, TItem2, TItem3, TParams, TResult>(
    items1: TItem1[],
    items2: TItem2[],
    items3: TItem3[],
    buildRequest: (block1: TItem1[], block2: TItem2[], block3: TItem3[]) => IRequest<TParams, TResult>,
    blockSize: number = DefaultBlockSize
  ): IRequest<TParams, TResult>[] {
    const requests: IRequest<TParams, TResult>[] = [];
    const blocks1 = makeBlocks(items1, blockSize);
    const blocks2 = makeBlocks(items2, blockSize);
    const blocks3 = makeBlocks(items3, blockSize);
    for (let i1 = 0, l1 = blocks1.length; i1 < l1; i1++) {
      for (let i2 = 0, l2 = blocks2.length; i2 < l2; i2++) {
        for (let i3 = 0, l3 = blocks3.length; i3 < l3; i3++) {
          const request = buildRequest(blocks1[i1], blocks2[i2], blocks3[i3]);
          if (!!request) requests.push(request);
        }
      }
    }
    return requests;
  }

}
